import React from 'react';
import { applicationClosed, applicationRefund } from '../../assets/img';
import ApplicationInfoStatus from '../../components/application-info-status';
import { LandingPageLayout } from '../../layouts';

const ApplicationExpiredOrIncomplete = () => {
    return (
        <LandingPageLayout>
            <ApplicationInfoStatus
                appIcon={applicationRefund}
                appStatus="Your application has been closed"
                appMessage="Any funds provided for your deposit will be returned"
                appStatusType="closed"
                appStatusIcon={applicationClosed}
                appDetailMessage="If you provided a security deposit, a refund for the full amount will be processed within 5–10 business days. "
                appNotificationMessage={
                    <>
                        <p>
                            <b>We're sorry to see you go!</b>
                        </p>
                        <p>
                            Your application was closed for one of the following
                            reasons:
                            <ul>
                                <li>
                                    We needed additional information to verify your
                                    identity
                                </li>
                                <li>
                                    We didn't receive your required security deposit
                                </li>
                            </ul>
                        </p>
                        <p>
                            The good news is you can reapply at any time at&nbsp; 
                            <a href="https://openskycc.com">openskycc.com</a>. The
                            OpenSky Secured Visa Credit Card is a great tool to help
                            you build or rebuild solid credit history!
                        </p>
                    </>
                }
                onNext={() => window.location.href = `${process.env.REACT_APP_HOMEPAGE_URL}`}
                buttonText="Ok, Got it"
            />
        </LandingPageLayout>
    );
};

export default ApplicationExpiredOrIncomplete;
